/* eslint-disable consistent-return */
import { APP_SCROLL_ELEMENT } from '@doltech/core/lib/appScroll/withAppScroll';
import { computeCaretRect } from '@doltech/utils/lib/dom';
import isHotkey from 'is-hotkey';
import { Range } from 'slate';

import { SlatePlugin } from '../../../slatePlugins/slatePlugins.types';

let enterTimeOut = null;

export const EnterToScrollPlugin = (): SlatePlugin => {
  return {
    onKeyDown: (e, editor) => {
      const isEnterPress = isHotkey(['Enter'], e);
      if (isEnterPress && editor?.selection) {
        const { selection } = editor;
        if (Range.isCollapsed(selection)) {
          const caretRect = computeCaretRect(window);
          if (enterTimeOut) {
            clearTimeout(enterTimeOut);
          }
          enterTimeOut = setTimeout(() => {
            const currentCaretRect = computeCaretRect(window);
            const diff = currentCaretRect.top - caretRect.top;

            if (diff === 0) {
              return;
            }
            const scrollContainer = APP_SCROLL_ELEMENT;

            // The page must be scrollable.
            if (!scrollContainer) {
              return;
            }

            const scrollY = scrollContainer.scrollTop;
            const scrollContainerY = scrollContainer.getBoundingClientRect().top;
            const relativeScrollPosition =
              (caretRect.top - scrollContainerY) / (window.innerHeight - scrollContainerY);

            // If the scroll position is at the start, the active editable element
            // is the last one, and the caret is positioned within the initial
            // trigger percentage of the page, do not scroll the page.
            // The typewriter effect should not kick in until an empty page has been
            // filled with the initial trigger percentage or the user scrolls
            // intentionally down.
            if (scrollY === 0 && relativeScrollPosition < 0.75) {
              return;
            }

            const scrollContainerHeight = scrollContainer.clientHeight;
            // Abort if the target scroll position would scroll the caret out of view.
            if (
              // The caret is under the lower fold.
              caretRect.top + caretRect.height > scrollContainerY + scrollContainerHeight ||
              // The caret is above the upper fold.
              caretRect.top < scrollContainerY
            ) {
              return;
            }

            scrollContainer.scrollTop += diff;
          }, 1);
        }
      }
    },
  };
};
